import { Component, EventEmitter, Input, Output, SimpleChanges } from "@angular/core";
import { ConfiguratorDatastoreService, Partner } from "@tj/tj-dmp-lib-api";
import { ConfirmationService, MessageService } from "primeng/api";
import { AccountService } from "../../auth/account.service";

import { isAdminOfTenant } from "../../auth/admin-levels";
@Component({
    selector: 'dmp-select-affected-partners',
    templateUrl: './select-affected-partners.component.html',
    styleUrls: ['./select-affected-partners.component.scss'],
    providers: [ConfirmationService, MessageService],
    standalone: false
})
export class SelectAffectedPartnersComponent {
    partnersList: Partner[] = [];
    oldSelectedAffectedPartners: string[] = [];

    isAuthorizedAdmin: boolean;
    settingDialog: boolean = false;

    @Input() datastore: string;
    @Input() hasPartner: boolean = false;
    @Input() selectedAffectedPartners: string[] = [];
    /** Texte affiché sous le titre de la modale : ce que l'affectation permet sur cet écran. */
    @Input() description: string;
    @Output() onSave = new EventEmitter<string[]>();

    constructor(
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private accountService: AccountService,
        private configuratorDatastoreService: ConfiguratorDatastoreService
    ) { }

    ngOnInit() {
        this.accountService.fetch().subscribe((account) => {
            this.isAuthorizedAdmin = isAdminOfTenant(account, this.datastore);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['datastore'] && changes['datastore'].currentValue) {
            this.datastore = changes['datastore'].currentValue;

            // Charger les informations de l'utilisateur puis les partners
            this.accountService.fetch().subscribe((account) => {
                this.isAuthorizedAdmin = isAdminOfTenant(account, this.datastore);
                // Charger les partners après avoir déterminé si l'utilisateur est admin
                this.loadPartners(this.datastore);
            });
        }
    }

    private loadPartners(tenant: string) {
        this.configuratorDatastoreService.getDatastoreUsingGET(tenant, true).subscribe(res => {
            // Si l'utilisateur n'est pas admin, filtrer les partners selon ses permissions
            if (!this.isAuthorizedAdmin) {
                this.configuratorDatastoreService.getDatastoreAccessiblePartnersUsingGET(tenant, true).subscribe(accessiblePartnerCodes => {
                    // Filtrer pour ne garder que les partners accessibles
                    this.partnersList = res.partners.filter(partner =>
                        accessiblePartnerCodes.includes(partner.code)
                    );
                });
            } else {
                // Si admin, afficher tous les partners
                this.partnersList = res.partners;
            }
        });
    }

    public openSetting() {
        this.oldSelectedAffectedPartners = [...this.selectedAffectedPartners];
        // Travailler sur une copie : le tableau reçu en @Input est la référence détenue par le
        // parent. togglePartner() faisant un push, éditer directement cette référence appliquait
        // les changements au parent avant validation, et rendait l'annulation sans effet.
        this.selectedAffectedPartners = [...this.selectedAffectedPartners];
        this.settingDialog = true;
    }

    public cancelSetting() {
        this.selectedAffectedPartners = [...this.oldSelectedAffectedPartners];
        this.settingDialog = false;
    }

    public validateSetting() {
        this.confirmationService.confirm({
            message: 'Voulez-vous vraiment modifier les affiliés de ce préset ?',
            accept: () => {
                this.oldSelectedAffectedPartners = [];
                this.settingDialog = false;
                this.selectedAffectedPartners = this.partnersList
                    .map(partner => partner.code)
                    .filter(code => this.selectedAffectedPartners.includes(code));
                this.onSave.emit(this.selectedAffectedPartners);
            }
        });
    }

    togglePartner(partner: Partner, isChecked: boolean) {
        if (isChecked) {
            this.selectedAffectedPartners.push(partner.code);
        } else {
            this.selectedAffectedPartners = this.selectedAffectedPartners.filter(p => p !== partner.code);
        }
    }

    isSelected(partner: Partner): boolean {
        return this.selectedAffectedPartners.includes(partner.code);
    }

    canAffectPartners(): boolean {
        if (this.hasPartner) {
            return false;
        } else {
            return this.isAuthorizedAdmin;
        }
    }

}